import { useEffect, useState } from "react";
import { BUSINESS } from "@/data";
import { CallButton, QuoteButton, Logo } from "./Buttons";
import * as Icons from "lucide-react";

const NAV = [
  { label: "Repairs", href: "#pricing" },
  { label: "Phones", href: "#products" },
  { label: "Accessories", href: "#products" },
  { label: "Prepaid", href: "#prepaid" },
  { label: "Sell Phone", href: "#sell" },
  { label: "About", href: "#why" },
  { label: "Contact", href: "#visit" },
];

export default function Header({ onOpenQuote }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Top bar — matches yourphoneplug.com header strip */}
      <div className="hidden md:block bg-brand-navy text-white text-xs">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-2 flex items-center justify-between gap-4">
          <span className="tracking-wider font-semibold text-white/90">*** {BUSINESS.tagline} ***</span>
          <div className="flex items-center gap-4">
            <a href={`tel:${BUSINESS.phoneTel}`} data-testid="topbar-phone" className="hover:text-brand-red transition-colors">{BUSINESS.phone}</a>
            <span className="text-white/30">|</span>
            <a href={`mailto:${BUSINESS.email}`} data-testid="topbar-email" className="hover:text-brand-red transition-colors">{BUSINESS.email}</a>
          </div>
        </div>
      </div>

      <header
        data-testid="site-header"
        className={`sticky top-0 inset-x-0 z-50 bg-white transition-all duration-300 ${
          scrolled ? "shadow-md py-3" : "py-4 border-b border-slate-100"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between gap-4">
          <a href="#top" className="flex items-center gap-2.5 group" data-testid="logo-link">
            <Logo size="md" />
            <div className="leading-none">
              <div className="font-display font-extrabold text-base text-brand-navy tracking-tight">Your Phone Plug</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-brand-red font-semibold mt-1">Miami Gardens, FL</div>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-1" data-testid="primary-nav">
            {NAV.map((n) => (
              <a
                key={n.label}
                href={n.href}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="px-3.5 py-2 text-sm font-medium text-slate-700 hover:text-brand-red rounded-full transition-colors"
              >
                {n.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-2">
            <QuoteButton testid="header-quote-btn" onClick={onOpenQuote} variant="outline" size="md">
              Get Quote
            </QuoteButton>
            <CallButton testid="header-call-btn" size="md">
              {BUSINESS.phone}
            </CallButton>
          </div>

          {/* Mobile call + menu */}
          <div className="flex md:hidden items-center gap-2">
            <CallButton testid="header-mobile-call" size="sm">Call</CallButton>
            <button
              data-testid="mobile-menu-toggle"
              onClick={() => setOpen((v) => !v)}
              className="p-2.5 rounded-full bg-slate-100 hover:bg-slate-200 border border-slate-200"
              aria-label="Toggle menu"
            >
              {open ? <Icons.X className="w-5 h-5 text-brand-navy" /> : <Icons.Menu className="w-5 h-5 text-brand-navy" />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden bg-white border-t border-slate-100 mt-3" data-testid="mobile-menu">
            <div className="max-w-7xl mx-auto px-4 py-4 grid grid-cols-2 gap-2">
              {NAV.map((n) => (
                <a
                  key={n.label}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="px-4 py-3 rounded-xl bg-slate-50 text-brand-navy text-sm font-semibold hover:bg-slate-100 border border-slate-100"
                >
                  {n.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </header>
    </>
  );
}
